import { apiClient } from './client.tsx';
import type {
  CreatePartnerAccountantRequest,
  UpdatePartnerAccountantRequest,
} from './requests/partner-accountant-request.ts';

type UpdateRequestWithoutId = Omit<UpdatePartnerAccountantRequest, 'id'>;

export const fetchPartnerAccountants = (partnerId: string) =>
  apiClient
    .get(`/v2/partner_accountants?partnerId=${partnerId}`)
    .then((res) => res.data.data);

export const fetchPartnerAccountant = (id: string) =>
  apiClient.get(`/v2/partner_accountants/${id}`).then((res) => res.data.data);

export const createPartnerAccountant = (
  request: CreatePartnerAccountantRequest,
) =>
  apiClient
    .post(`/v2/partner_accountants`, request)
    .then((res) => res.data.data);

export const updatePartnerAccountant = (
  request: UpdatePartnerAccountantRequest,
) =>
  apiClient
    .put(
      `/v2/partner_accountants/${request.id}`,
      <UpdateRequestWithoutId>request,
    )
    .then((res) => res.data);

export const voidPartnerAccountant = (id: string) =>
  apiClient.delete(`/v2/partner_accountants/${id}`).then((res) => res.data);
